import React from 'react';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import { getFileUrl } from '@/services/CommonService';

const FeaturedItemsComponent = ({ dataSource }) => {
    return (
        <Card>
            <CardHeader isBorder={true}>
                <h3 className="db-card-title">Featured Items</h3>
            </CardHeader>
            <CardBody>
                <ul className="grid grid-cols-2 sm:grid-cols-4 gap-[18px]">
                    {dataSource?.fetures_items &&
                        dataSource?.fetures_items?.length > 0 &&
                        dataSource?.fetures_items.map((data, index) => (
                            <li key={index} className="w-full rounded-xl border border-[#D9DBE9]">
                                <img className="product-card-grid-image w-[260px] min-h-[120px] h-[120px] object-cover object-center" src={getFileUrl(data?.file_name, 'product')} alt="product" />
                                <h4 className="text-xs p-2 font-medium capitalize">{data.name}</h4>
                            </li>
                        ))}
                </ul>
            </CardBody>
        </Card>
    );
};

export default FeaturedItemsComponent;
